import { render } from "./SelectFish.vue?vue&type=template&id=41ca2d41&scoped=true&ts=true"
import script from "./SelectFish.vue?vue&type=script&lang=ts"
export * from "./SelectFish.vue?vue&type=script&lang=ts"

import "./SelectFish.vue?vue&type=style&index=0&id=41ca2d41&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ca2d41"]])

export default __exports__